import React from "react";
import withIntl from "../../utils/withIntl";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";
import CheckboxSetting from "../SettingFields/CheckboxSetting";
import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";
import IconButton from "@material-ui/core/IconButton";
import { Tooltip } from "@material-ui/core";
import TextSetting from "../SettingFields/TextSetting";
import PaynlPinterminal from "./Paynl/PaynlPinterminal";
import PaynlMerchant from "./Paynl/PaynlMerchant";

function PaymentMethod(props) {
  return (
    <div>
      <div style={{ display: "flex", alignItems: "center" }}>
        <Typography style={{ fontWeight: 600, width: "90%" }}>{props.paymentMethod.name}</Typography>
        <Tooltip title={props.intl.formatMessage({ id: "remove_payment_method" })}>
          <IconButton onClick={props.handleRemovePaymentMethod}>
            <RemoveCircleOutlineIcon />
          </IconButton>
        </Tooltip>
      </div>
      <div style={{ marginLeft: 20 }}>
        <CheckboxSetting
          label={props.intl.formatMessage({ id: "is_turnover" })}
          authenticationName={"sp_merchant.handheld.payment_methods"}
          // key={setting.key + "-" + spMerchant.updated_at}
          setting={{ value: props.paymentMethod.is_turnover ?? true }}
          onChange={(checked) => {
            let newPaymentMethod = { ...props.paymentMethod };
            if (!checked) {
              newPaymentMethod.is_turnover = false;
            } else {
              delete newPaymentMethod.is_turnover;
            }
            props.handleUpdatePaymentMethods(newPaymentMethod);
          }}
        />
        <Divider style={{ marginTop: "4px", marginBottom: "4px" }} />
        <CheckboxSetting
          label={props.intl.formatMessage({ id: "Open cash drawer" })}
          authenticationName={"sp_merchant.handheld.payment_methods"}
          // key={setting.key + "-" + spMerchant.updated_at}
          setting={{ value: props.paymentMethod.open_cash_drawer ?? false }}
          onChange={(checked) => {
            let newPaymentMethod = { ...props.paymentMethod };
            if (!checked) {
              newPaymentMethod.open_cash_drawer = false;
            } else {
              newPaymentMethod.open_cash_drawer = true;
            }
            props.handleUpdatePaymentMethods(newPaymentMethod);
          }}
        />
        <Divider style={{ marginTop: "4px", marginBottom: "4px" }} />
        <CheckboxSetting
          label={props.intl.formatMessage({ id: "free_percentage" })}
          authenticationName={"sp_merchant.handheld.payment_methods"}
          // key={setting.key + "-" + spMerchant.updated_at}
          setting={{ value: props.paymentMethod.free_percentage ? 1 : 0 }}
          onChange={(checked) => {
            let newPaymentMethod = { ...props.paymentMethod };
            if (checked) {
              newPaymentMethod.free_percentage = 1;
            } else {
              delete newPaymentMethod.free_percentage;
            }
            props.handleUpdatePaymentMethods(newPaymentMethod);
          }}
        />
        <Divider style={{ marginTop: "4px", marginBottom: "4px" }} />
        <TextSetting
          label={props.intl.formatMessage({ id: "default_amount" })}
          authenticationName={"sp_merchant.handheld.payment_methods"}
          setting={{
            value: props.paymentMethod.default_amount ? (props.paymentMethod.default_amount / 100.0).toFixed(2) : "",
          }}
          onChange={(value) => {
            let newPaymentMethod = { ...props.paymentMethod };
            if (typeof parseFloat(value) === "number" && value !== "") {
              newPaymentMethod.default_amount = Math.round(parseFloat(value) * 100);
            } else {
              delete newPaymentMethod.default_amount;
            }
            props.handleUpdatePaymentMethods(newPaymentMethod);
          }}
        />
        <Divider style={{ marginTop: "4px", marginBottom: "4px" }} />
        <TextSetting
          label={props.intl.formatMessage({ id: "percentage %" })}
          authenticationName={"sp_merchant.handheld.payment_methods"}
          setting={{
            value: props.paymentMethod.default_percentage ? props.paymentMethod.default_percentage : "",
          }}
          onChange={(value) => {
            let newPaymentMethod = { ...props.paymentMethod };
            if (typeof parseFloat(value) === "number" && value !== "") {
              newPaymentMethod.default_percentage = parseFloat(value);
            } else {
              delete newPaymentMethod.default_percentage;
            }
            props.handleUpdatePaymentMethods(newPaymentMethod);
          }}
        />
        <PaynlPinterminal
          paymentMethod={props.paymentMethod}
          updatePaynlPinterminal={(value) => {
            let newPaymentMethod = { ...props.paymentMethod };
            if (value) {
              newPaymentMethod.paynlPinTerminal = value;
            } else {
              delete newPaymentMethod.paynlPinTerminal;
            }
            props.handleUpdatePaymentMethods(newPaymentMethod);
          }}
        />
        <PaynlMerchant
          paymentMethod={props.paymentMethod}
          updatePaynlMerchant={(value) => {
            let newPaymentMethod = { ...props.paymentMethod };
            if (value) {
              newPaymentMethod.paynlMerchant = value;
            } else {
              delete newPaymentMethod.paynlMerchant;
            }
            props.handleUpdatePaymentMethods(newPaymentMethod);
          }}
        />
      </div>
    </div>
  );
}

export default withIntl(PaymentMethod);
